import { FaHtml5, FaCss3Alt, FaJsSquare, FaReact } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { BsFillLightbulbFill } from "react-icons/bs";

const WhatWeCoverSection = () => {
    const topics = [
        {
            id: 1,
            title: "HTML & Semantic Markup",
            icon: FaHtml5,
            points: [
                "Writing semantic HTML that actually makes sense",
                "Accessibility patterns that work in real projects",
                "SEO fundamentals every frontend dev should know",
            ],
        },
        {
            id: 2,
            title: "CSS & Modern Styling",
            icon: FaCss3Alt,
            points: [
                "Flexbox and Grid layouts that don't break",
                "CSS architecture and naming conventions",
                "Animations and transitions done right",
            ],
        },
        {
            id: 3,
            title: "JavaScript Fundamentals",
            icon: FaJsSquare,
            points: [
                "Core concepts: closures, promises, async/await",
                "DOM manipulation best practices",
                "Event handling patterns that scale",
            ],
        },
        {
            id: 4,
            title: "Modern Frameworks",
            icon: FaReact,
            points: [
                "React patterns and anti-patterns",
                "State management strategies",
                "Performance optimization techniques",
            ],
        },
    ];

    return (
        <section className="row mx-0 justify-content-center align-items-center my-5 py-5">
            <div className="col-12 col-md-10 text-light">
                <div className="row mx-0 text-center justify-content-center mb-5">
                    <div className="col-12 col-md-8">
                        <h1 className="fw-bold">What We’ll Cover Together</h1>
                        <p className="mt-2">
                            From the basics you might have missed to the advanced patterns
                            that separate good developers from great ones.
                        </p>
                    </div>
                </div>
                <div className="row mx-0 d-flex align-items-center mb-5">
                    {topics.map((item) => (
                        <div className="col-12 col-md-6 mb-4" key={item.id}>
                            <div className="p-4 radius-10 bg-light text-dark border h-100">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="ml-0 fs-3 text-custom">
                                        <item.icon size={32} />
                                    </div>
                                    <h5 className="fw-bold mb-0 ml-2">{item.title}</h5>
                                </div>

                                <ul className="list-unstyled mb-0">
                                    {item.points.map((point, index) => (
                                        <li key={index} className="mb-2 text-muted">
                                            <TiTick className="text-custom" />  {point}
                                        </li>
                                    ))}
                                </ul>

                            </div>
                        </div>
                    ))}
                </div>

                <div className="row mx-0">
                    <div className="col-12">
                        <div className="p-4 p-md-5 radius-10 border">
                            <div className="d-flex mb-3">
                                <i><BsFillLightbulbFill className="text-pink" size={24} /></i>
                                <h5 className="fw-bold ml-2">
                                    Plus: Tips, Tricks & Do&apos;s / Don&apos;ts
                                </h5>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-md-4">
                                    <h6 className="fw-bold text-pink">Code Quality</h6>
                                    <p className="text-muted small">
                                        Writing clean, maintainable code that your future self will thank you for.
                                    </p>
                                </div>

                                <div className="col-12 col-md-4">
                                    <h6 className="fw-bold text-pink">Debugging Strategies</h6>
                                    <p className="text-muted small">
                                        How to find and fix bugs faster than you create them.
                                    </p>
                                </div>

                                <div className="col-12 col-md-4">
                                    <h6 className="fw-bold text-pink">Career Advice</h6>
                                    <p className="text-muted small">
                                        What hiring managers actually look for in frontend developers.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default WhatWeCoverSection;
